import { useScreenWidth } from "./getScreenWidth";

const useCardWidth = () => {
  const windowWidth = useScreenWidth();

  let cardWidth;

  if (windowWidth >= 1200) {
    cardWidth = 362;
  } else if (windowWidth >= 768) {
    cardWidth = 320;
  } else if (windowWidth >= 414) {
    cardWidth = 300;
  } else {
    cardWidth = "80%";
  }

  return cardWidth;
};

export default useCardWidth;
